// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Qbes","inputWrap":"CustomTip_inputWrap__k0RUK"};